module.exports = __webpack_public_path__ + "f8003cd1b712417cc059404beaaa92d7.jpg";